import { apiRequest } from './client'
import type { MyOrg, Permission, Role, SessionInfo, User } from './types'

export const fetchMe = () => apiRequest<{ user: User; orgs: MyOrg[] }>('GET', '/api/me')

export const updateMe = (input: { name: string }) => apiRequest<{ user: User }>('PATCH', '/api/me', input)

export const changePassword = (input: { currentPassword?: string; newPassword: string }) =>
  apiRequest('POST', '/api/me/password', input)

export const fetchSessions = () => apiRequest<{ sessions: SessionInfo[] }>('GET', '/api/me/sessions')

export const revokeSession = (sessionId: string) => apiRequest('DELETE', `/api/me/sessions/${sessionId}`)

export const fetchRoles = () =>
  apiRequest<{ roles: { role: Role; permissions: Permission[] }[] }>('GET', '/api/me/roles')
